
import ReactDOM from 'react-dom/client';
import { store } from "./State/store";
import { Provider } from "react-redux";
import React from "react";
import '../index.css';

import App from './App.tsx';
import { ThemeProvider } from "@/components/theme/ThemeProvider"; // ✅ Add this import

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js');
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider> {/* ✅ Wrap App with ThemeProvider */}
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
